export function roundN(nr: number, decimals?: number): number {
  if (!decimals) {
    decimals = 0;
  }
  const z = Math.pow(10, decimals);
  return Math.round(nr * z) / z;
}
